import {
  Autocomplete,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { Box } from '@material-ui/core';
import VehicalChecklistTable from './VehicalChecklistTable';
import AdditionalInfoSection from './AdditionalInfoSection';
import { DropzoneUpload } from './InputsRendered';
import { EmployeeNameField, DateTimeField } from './SharedFormFields';
import { ALL_TASK_OPTIONS } from './GeneralTaskForm';

const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};

const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': { fontSize: '0.82rem', fontWeight: 500 },
    },
  },
};

const RepairAndMaintananceForm = ({
  data,
  setData,
  checklistOptions,
  vehicalOption,
  checkListData,
  handleCheckListEdit,
  typeOfRepairoption,
  files,
  isLoading,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  isAdd = false,
  onTaskChange,
}) => {
  const handleChangeData = (name, value) => {
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': { fontSize: '0.825rem' },
        '& .MuiInputBase-root': { fontSize: '0.825rem !important' },
        paddingBottom: '1rem',
      }}>
      {/* Shared fields */}
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} />
      <DateTimeField value={data['dateAndTime']} onChange={handleChangeData} />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Type of Repair
        </InputLabel>
        <Autocomplete
          size="small"
          disablePortal
          value={data['typeOfRepair'] || null}
          options={typeOfRepairoption}
          onChange={(_, newValue) => handleChangeData('typeOfRepair', newValue || '')}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{ ...autoCompleteSlotProps }}
        />
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Vehicle
        </InputLabel>
        <Autocomplete
          size="small"
          disablePortal
          value={data['vehicle'] || null}
          options={vehicalOption}
          onChange={(_, newValue) => handleChangeData('vehicle', newValue || '')}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{ ...autoCompleteSlotProps }}
        />
      </Grid>

      <InputFields
        label="Mileage (Odometer Reading in KM)"
        name="mileageReadingKM"
        required
        value={data['mileageReadingKM']}
        textFieldType="number"
        width={4}
        handleIpChange={handleChangeData}
      />

      <VehicalChecklistTable
        checkListOptions={checklistOptions}
        checklistData={checkListData}
        handleCheckListDataEdit={handleCheckListEdit}
      />

      <Grid item xs={12} sx={{ alignContent: 'end' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingInline: '1rem' }}>
          <Typography variant="subtitle2">
            I confirm that I have fully completed the Vehicle Check List and all issues have been noted above *
          </Typography>
          <Checkbox
            required
            checked={data['vehicleCheckListCompleted'] && data['vehicleCheckListCompleted'] == '1'}
            onChange={e => handleChangeData('vehicleCheckListCompleted', e.target.checked ? '1' : '0')}
          />
        </div>
      </Grid>

      <InputFields
        label="Detail of All Repairs/Expenses Incurred"
        name="detailOfAllRepairsExpensesIncurred"
        required
        value={data['detailOfAllRepairsExpensesIncurred']}
        textFieldType="text"
        width={12}
        multiline
        handleIpChange={handleChangeData}
      />

      <Grid item xs={12} sm={12} md={6}>
        <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('files')} multiple />
        <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1, px: 0.5, alignItems: 'center', minHeight: 60 }}>
          {isLoading ? (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress size={22} />
              <Typography style={{ marginLeft: 8 }}>Fetching Docs...</Typography>
            </Box>
          ) : files && files.length > 0 ? (
            files.map((file, index) => (
              <Tooltip title={file.docName} key={index}>
                <div>
                  <Chip
                    label={file?.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                    color="success"
                    sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                    onDelete={() => handleDeleteFiles(file)}
                    onClick={() => viewFile && viewFile(file)}
                  />
                </div>
              </Tooltip>
            ))
          ) : (
            <Typography>No files uploaded.</Typography>
          )}
        </Box>
      </Grid>

      <InputFields
        label="Cost Incurred"
        name="costIncurred"
        required
        value={data['costIncurred']}
        textFieldType="number"
        width={6}
        multiline
        handleIpChange={handleChangeData}
      />

      <AdditionalInfoSection data={data} handleChange={handleChangeData} />
    </Grid>
  );
};

export default RepairAndMaintananceForm;
